<template>
  <!-- 異体字を指定している場合 -->
  <!-- 異体字画像を表示-->
  <!-- 異体字画像を指定していない場合-->
  <!-- 異体字候補の1番目異体字を表示する -->
  <div
    class="character"
    :style="{
      height: `${size}px`,
      width: `${size}px`,
    }"
  >
    <img
      v-if="!itaijiError"
      class="Character"
      :src="!char.imageUrl ? genItaijiImagePath(char.character) : char.imageUrl"
      :alt="char.character"
      :style="{
        height: `${size}px`,
        width: `${size}px`,
      }"
      @error="onLoadError"
      @click="_onClickCharacter(char, text)"
    />
    <!-- デフォルトの文字画像が存在しない場合、テキストを表示する -->
    <span
      v-if="defaultImageError && itaijiError"
      class="defaultText"
      :style="{ fontSize: `${size - 10}px` }"
    >
      {{ char.character }}
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      itaijiError: false,
      defaultImageError: false,
    };
  },
  props: {
    raw: {
      type: Boolean,
      default: false,
    },
    font: {
      type: String,
      default: "標準書体",
    },
    text: {
      type: [Boolean, String],
      default: "",
    },
    size: {
      type: Number,
      default: 25,
    },
    onClickCharacter: {
      type: Function,
      default: () => {},
    },
    spaceAround: {
      type: Boolean,
      default: false,
    },
    spaceAfter: {
      type: Number,
      default: 0,
    },
    char: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  computed: {},
  watch: {
    char: {
      deep: true,
      handler: function () {
        this.itaijiError = false;
        this.defaultImageError = false;
      },
    },
  },
  methods: {
    genItaijiImagePath (character) {
      if (!character) {
        return "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7";
      }

      // 「手書き」または「SK書体」を選択した場合、該当する文字画像が用意されていないため
      // 「機械書(合掌体)」の文字画像を表示するようにする
      // 「機械書手彫風書体」を選択した場合は「手彫り風書体」の文字画像を表示する
      const fetchFont = (selectedFont) => {
        if (
          selectedFont === "手書き" ||
          selectedFont === "SK書体"
        ) {
          return "合掌体";
        }
        if (selectedFont === "機械書手彫風書体") {
          return "手彫り風書体";
        }

        return selectedFont;
      };
      const font = fetchFont(this.font);

      return `https://alte-meister-static-test.s3.ap-northeast-1.amazonaws.com/variantCharacterDatabase/文字/${font}/${character}.png`;
    },
    onLoadError () {
      this.itaijiError = true;
      this.defaultImageError = true;
    },
    _onClickCharacter (character, text) {
      // characterIndexは親で指定する
      this.$emit("onClickCharacter", {
        character: character.character,
        characterDetail: character,
        text,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.defaultText {
  font-family: "凸版文久明朝", "游明朝", YuMincho, "Hiragino Mincho ProN W3",
    "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝",
    "ＭＳ 明朝", serif;
}
.Character {
  width: 30px;
  vertical-align: top;
}
.Character > * {
  display: inline;
}
.SpaceAround {
  display: flex;
  justify-content: space-around;
}
.CharacterSpacer {
  display: inline-block;
}
.isShown {
  display: inline;
}
.isHidden {
  display: none;
}
</style>
